import axios from "axios";
import {
  Button,
  Card,
  Box,
  CardHeader,
  CardBody,
  CardFooter,
  FormLabel,
  Text,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from "@chakra-ui/react";

import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../../constants/defaultValues";
import { useState } from "react";
const LoginConfirmation = ({ nextStep }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const registerData = useSelector((state) => state.register);
  const handleSubmit = async () => {
    setIsProcessing(true);
    console.log(registerData);
    // const result = await axios.post(`${BASE_URL}/api/auth/registerUser`, {
    //   first_name: registerData.firstname,
    //   last_name: registerData.lastname,
    //   token: registerData?.card?.id,
    //   email: registerData.email,
    //   password: registerData.password,
    //   account_name: registerData.accountname,
    //   phone:
    //     registerData.currentnumber.length > 0
    //       ? registerData.currentnumber
    //       : registerData.newnumber,
    //   plan_name: registerData.plan.name,
    //   CustomerName: registerData.accountname,
    //   Street: registerData.street,
    //   City: registerData.city,
    //   Region: registerData.region,
    //   IsoCountry: registerData.isocountry,
    //   PostalCode: registerData.postalcode,
    //   ContactPhoneNumber:
    //     registerData.currentnumber.length > 0
    //       ? registerData.currentnumber
    //       : registerData.newnumber,
    //   isHostedNumber: registerData.currentnumber.length > 0 ? true : false,
    // });
    // // console.log(result)
    // if (result?.data?.error == "false") {
    //   onOpen();
    //   setIsProcessing(false);
    // } else {
    //   alert(result?.data?.message);
    //   setIsProcessing(false);
    // }
    //   const { id } = registerData.card;
    //   const response = await fetch("/create-payment-intent", {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify({
    //       amount: registerData.plan.price,
    //       id,
    //     }),
    //   });
    //   if (response.data.success) {
    //     console.log("Successful");
    //   }
    //   console.log("Unsuccessful");
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <Card p="15px" w={{ base: "90%", md: "70%", lg: "60%" }}>
        <CardHeader color="#2A3042" fontSize="26px" fontWeight="semibold">
          Let's make sure everything looks correct
        </CardHeader>

        <CardBody>
          <Box display="flex" flexDir="column" gap="15px">
            <Box>
              <span
                style={{
                  fontWeight: "700",
                  marginRight: "10px",
                }}
              >
                Name:
              </span>
              <span>
                {registerData.firstname + " " + registerData.lastname}
              </span>
            </Box>
            <Box>
              <span
                style={{
                  fontWeight: "700",
                  marginRight: "10px",
                }}
              >
                Email:
              </span>
              <span>{registerData.email}</span>
            </Box>
            <Box>
              <span
                style={{
                  fontWeight: "700",
                  marginRight: "10px",
                }}
              >
                Account Name:
              </span>
              <span>{registerData.accountname}</span>
            </Box>
            <Box>
              <span
                style={{
                  fontWeight: "700",
                  marginRight: "10px",
                }}
              >
                Plan:
              </span>
              <span>{registerData.plan.name} </span>
            </Box>
            <Box>
              <span
                style={{
                  fontWeight: "700",
                  marginRight: "10px",
                }}
              >
                Number:
              </span>
              <span>
                {registerData.currentnumber
                  ? registerData.currentnumber
                  : registerData.newnumber}
              </span>
            </Box>
            {/* <Box>
              <span
                style={{
                  fontWeight: "700",
                  marginRight: "10px",
                }}
              >
                Card:
              </span>
              <span>**** **** **** {registerData.card.card.last4}</span>
            </Box> */}
          </Box>
        </CardBody>
      </Card>
      {/* <Modal
        size="lg"
        closeOnEsc={false}
        closeOnOverlayClick={false}
        isOpen={isOpen}
        onClose={onClose}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Account Created Succesfully</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>
              {registerData.currentnumber
                ? " “Thank you! We’re sending you a confirmation email now. Click the login button below to sign in to your account.”"
                : "Thank you! It can take up to 24 hours for your phone number to be hosted on the Inca platform. We will send you an email letting you know your number is ready to use for texting as soon as that process is complete. You may click the login button below to sign in to your account but you won’t be able to send or receive messages until your number is hosted."}
            </Text>
          </ModalBody>
          <ModalFooter>
            <Button
              variant="ghost"
              colorScheme="blue"
              mr={3}
              onClick={() => {
                onClose();
                navigate("/login");
              }}
            >
              Close
            </Button>
            <Button
              variant="solid"
              colorScheme="blue"
              onClick={() => navigate("/login")}
            >
              Login
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal> */}
    </Box>
  );
};

export default LoginConfirmation;
